// src/money.ts
var Money = class Money {
	cents;
	constructor(cents) {
		this.cents = cents;
	}
	static cents(cents) {
		return new Money(cents);
	}
	static euros(euros) {
		return new Money(Math.round(euros * 100));
	}
	get inEuros() {
		return this.cents / 100;
	}
	get inCents() {
		return this.cents;
	}
	toString() {
		return `${this.inEuros.toFixed(2)} €`;
	}
};
export { Money };

//# sourceMappingURL=index.mjs.map